import React, { useState } from "react";
import { ASSET_PATH } from "../utilities";
import closeIcon from "./close-grey.svg";
import closeIconHover from "./close-orange.svg";

export const ContentBookItem = ({ bookData, onRemoveIsbn }) => {
    const [isFadingOut, setIsFadingOut] = useState(false);
    const fadeOut = () => {
        setIsFadingOut(true);
    };
    const handleRemoveItem = (isbn) => {
        onRemoveIsbn(isbn);
        setIsFadingOut(false);
    };
    return (
        <div
            key={bookData.isbn}
            className={`side-panel-book-list-row-container ${
                isFadingOut ? "fadeout" : ""
            }`}
        >
            <div className="side-panel-book-list-row">
                <div className="book-cover">
                    <a
                        href={
                            window.prhReactWishlistSidePanel.siteBase +
                            "/book/?isbn=" +
                            bookData.isbn
                        }
                    >
                        <img
                            src={bookData.cover_image}
                            alt={`${bookData.title} cover`}
                        />
                    </a>
                </div>
                <a
                    href={
                        window.prhReactWishlistSidePanel.siteBase +
                        "/book/?isbn=" +
                        bookData.isbn
                    }
                >
                    <div className="book-text">{bookData.title}</div>
                </a>
                <div className="remove-button-wrapper">
                    <button
                        className="remove-button"
                        onClick={() => {
                            fadeOut(
                                setTimeout(
                                    () => handleRemoveItem(bookData.isbn),
                                    300
                                )
                            );
                        }}
                    >
                        <img
                            src={ASSET_PATH + closeIcon}
                            className="default"
                            alt="Close"
                        />
                        <img
                            src={ASSET_PATH + closeIconHover}
                            className="hover"
                            alt="Close"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/modules/ContentBookItem.js